import { render, staticRenderFns } from "./PreciseProductNameFormation.vue?vue&type=template&id=a5d36ff2&scoped=true"
import script from "./PreciseProductNameFormation.vue?vue&type=script&lang=js"
export * from "./PreciseProductNameFormation.vue?vue&type=script&lang=js"
import style0 from "./PreciseProductNameFormation.vue?vue&type=style&index=0&id=a5d36ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d36ff2",
  null
  
)

export default component.exports